
        import '/home/builduser/work/c1dd1064fea009a6/santa-editor/packages/previewer/components/previewerItem.scss.css.virtualfile';
        module.exports = {"item":"_item_15i40_1","overlay":"_overlay_15i40_5"};